/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface IgnitionOnEventOffsetUSMarker {
  size?: number,
  borderColor?: string,
  fillColor?: string
};

/**
 * Utility function that returns an image from SVG that can be passed
 * to the esri Graphic constructor to make a graphic with Offset for ignition on events of the asset
 *
 * ```typescript
 *  import {getIgnitionOnEventOffsetUSMarker} from '@ion/dls/src/maps/markers';
 *
 *  return {
 *    type   : 'picture-marker',
 *    url    : getIgnitionOnEventOffsetUSMarker({size, fillColor}),
 *    width  : size,
 *    height : size,
 *    angle  : 0
 * }
 * ```
 */
export const getIgnitionOnEventOffsetUSMarker = ({
  fillColor = dlsColor('caGreen'),
  borderColor = dlsColor('white'),
  size = 48
}: IgnitionOnEventOffsetUSMarker) => {
  const svg = (`
    <svg width='${size}' height='${size}' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='24' y='12' width='24' height='24' rx='12' fill='${borderColor}'/>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M36 34C30.4772 34 26 29.5228 26 24C26 18.4772 30.4772 14 36 14C41.5228 14 46 18.4772 46 24C45.9938 29.5203 41.5203 33.9938 36 34Z' fill='${fillColor}'/>
    </svg>
  `);
  return convertSvgToDataUri(svg.trim());
};

export default getIgnitionOnEventOffsetUSMarker;
